import Configurator from '../configurator'

export default function createGateConfigurator (definition) {
  const configId = definition.config_id || definition.id
  const instance = new Configurator({
    ...definition,
    config_id: configId
  })

  instance.config_id = configId

  if (!instance.id) {
    instance.id = configId
  }

  if (typeof instance.getDimensionStep !== 'function') {
    instance.getDimensionStep = function getDimensionStep () {
      return this.steps.find(step => step.type === 'dimension')
    }
  }

  return instance
}
